import { render, staticRenderFns } from "./SampleInputNumber.vue?vue&type=template&id=7308fe30"
import script from "./SampleInputNumber.vue?vue&type=script&lang=js"
export * from "./SampleInputNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7308fe30')) {
      api.createRecord('7308fe30', component.options)
    } else {
      api.reload('7308fe30', component.options)
    }
    module.hot.accept("./SampleInputNumber.vue?vue&type=template&id=7308fe30", function () {
      api.rerender('7308fe30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleInputNumber.vue"
export default component.exports